import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type WorkspaceSidebarBoardsListItemButtonProps = ComponentPropsWithoutRef<'button'>;

export const WorkspaceSidebarBoardsListItemButton = memo(
  forwardRef<HTMLButtonElement, WorkspaceSidebarBoardsListItemButtonProps>(({ className, ...restOfProps }, ref) => {
    return (
      <button
        className={cn(
          'flex size-6 shrink-0 items-center justify-center rounded-4 text-grey-10 hover:bg-grey-4 focus:ring-2 focus:ring-blue-9 active:bg-grey-4 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        type="button"
        {...restOfProps}
      />
    );
  }),
);

WorkspaceSidebarBoardsListItemButton.displayName = 'WorkspaceSidebarBoardsListItemButton';
